import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import * as actions from "../../../actions/internaciones";
import * as actionsNuevaPresentacion from "../../../actions/nuevaPresentacion";
import * as actionsAdjuntarArchivo from "../../../actions/adjuntarArchivo";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import * as actionsSnackMensaje from "../../../actions/snackMensaje";
import uploadService from "../../../services/upload-files";
import { Container, Typography, Tooltip } from "@material-ui/core";
import theme from "./theme";
import NuevaInternacion from "./NuevaInternacion";
import InternacionCargada from "./InternacionCargada";
import InternacionesMasivo from "./InternacionesMasivo";
import DocumentIcon from "@material-ui/icons/DescriptionOutlined";

class ListadoInternaciones extends Component {
    state = {
        indexEliminar: null,
    };

    actualizarInternacionHandler = (index) => {
        const internacion = this.props.internaciones[index];

        this.props.actualizarInfoInternacion(internacion, index);
    };

    cargarArchivosInternacion = (archivos, index = null) => {
        let _internacion = this.props.internacion;

        if (index === null) {
            this.props.subiendoNuevaInternacion(true);
        } else {
            _internacion = this.props.internaciones[index];
            this.props.internacionParaActualizar(_internacion);
        }

        this.props.subirArchivosNuevaInternacion(
            archivos,
            this.props.prestadorSeleccionado.codPrestador,
            this.props.pathTemp,
            _internacion
        );

        if (index === null) {
            const input = document.getElementById("nroInternacionInput");
            if (input) {
                input.value = null;
            }
        }
    };

    eliminarArchivoInternacion = (index, pathFile) => {
        const _internacion = this.props.internaciones[index];

        const archivo = _internacion.detalles.filter(
            (elemento) => elemento.pathArchivo === pathFile,
            []
        )[0];

        if (archivo.id === null) {
            uploadService.deleteFile(pathFile);
            _internacion.detalles = _internacion.detalles.filter(
                (archivo) => archivo.pathArchivo !== pathFile
            );
        } else {
            // Baja logica
            _internacion.detalles = _internacion.detalles.map((archivo) => {
                if (archivo.pathArchivo === pathFile) {
                    archivo.bajaLogica = true;
                }

                return archivo;
            });
        }

        this.props.actualizarInternacion(_internacion);

        const mensajeConfig = {
            mostrarSnack: true,
            mensajeSnack: "Archivo borrado con éxito " + archivo.nombreArchivo,
        };
        this.props.actualizarAtriutoSnackMensaje(mensajeConfig);
    };

    recuperarInformacionParaNuevaInternacion = (
        codPrestador,
        nroInternacion
    ) => {
        this.props.obtenerTempIdParaInternacion();
        this.props.recuperarInfoNroInternacion(codPrestador, nroInternacion);
    };

    cambiarVisibilidadBtn = () => {
        const mostrar = this.props.mostrarNuevaInternacion;

        this.props.actualizarAtriutoPresentacion({
            mostrarNuevaInternacion: !mostrar,
        });
    };

    eliminarInternacion = () => {
        const _internacion = this.props.internaciones[this.state.indexEliminar];

        if (_internacion.id) {
            _internacion.bajaLogica = true;
            this.props.actualizarInternacion(_internacion);
        } else {
            this.props.eliminarInternacion(this.state.indexEliminar);
        }
        //eliminar error de repetido de la primer ocurrencia
        const _tempInt = !_internacion.id;
        const _nuevaInt = this.props.internaciones.findIndex(
            (i) =>
                !i.bajaLogica &&
                ((!_tempInt && i.id !== _internacion.id) ||
                    (_tempInt && i.tempId !== _internacion.tempId)) &&
                parseInt(i.nroInternacion) ===
                    parseInt(_internacion.nroInternacion)
        );
        if (_nuevaInt >= 0)
            this.props.actualizarMensajesError(
                "nroInternacion" + _nuevaInt,
                null
            );

        this.setState({
            indexEliminar: null,
        });

        this.props.actualizarAtriutoVentanaDialogo({
            estaVisible: false,
        });
    };

    indexParaBorrar = (index) => {
        this.setState({
            indexEliminar: index,
        });

        const ventanaConfig = {
            estaVisible: true,
            titulo: "¿Esta seguro que desea eliminar el socio?",
            mensaje: "Se eliminarán los archivos relacionados",
            esAlerta: true,
            clickAceptar: this.eliminarInternacion,
            clickCancelar: () =>
                this.props.actualizarAtriutoVentanaDialogo({
                    estaVisible: false,
                }),
        };

        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    render() {
        if (
            !this.props.prestadorSeleccionado ||
            this.props.tipoPrestacionSeleccionada === 1 ||
            (this.props.tipoPrestacionSeleccionada === "" &&  this.props.tipoPresentacionSeleccionada !== 3 )||
            this.props.tipoComprobanteSeleccionado === 3 ||
            this.props.tipoComprobanteSeleccionado === 2
        ) {
            return null;
        }

        let internacionesCargadas = null;
        if (this.props.internaciones.length > 0) {
            internacionesCargadas = this.props.internaciones.map(
                (el, index) => (
                    <InternacionCargada
                        key={index}
                        internacion={{ ...el }}
                        index={index}
                        idPresentacion={this.props.tipoPresentacionSeleccionada}
                        deshabilitado={this.props.soloVista}
                        actualizarNroInternacionHandler={
                            this.props.actualizarNroInternacion
                        }
                        actualizarInternacionHandler={
                            this.actualizarInternacionHandler
                        }
                        cargarArchivosInternacionHandler={
                            this.cargarArchivosInternacion
                        }
                        eliminarArchivoInternacionHandler={
                            this.eliminarArchivoInternacion
                        }
                        indexBorradoHandler={this.indexParaBorrar}
                    />
                )
            );
        }

        const { internacion, requeridos } = this.props;
        const { classes } = this.props;
        return (
            <Container className={classes.container}>
                <Container
                    disableGutters={true}
                    className={classes.containerTitulo}
                >
                    <Typography className={classes.tituloSeccion}>
                        Imagenes por socio{" "}
                        {requeridos.internaciones.requerido ? "*" : ""}
                    </Typography>
                    <Tooltip
                        placement="right"
                        title={
                            <>
                                Requerido para internados
                                <br />
                                {`Ingresar el ${this.props.tipoPresentacionSeleccionada===3?'DNI de SOCIO':'NRO de INTERNACIÓN'}, el sistema
                                validará la autorización de ser correcto, en
                                caso de ser erróneo, saldrá el siguiente aviso: 
                                Asociado no encontrado`}
                                <br />
                                Para el ingreso masivo de Historias Clínicas el
                                nombre de los archivos deben respetar la
                                siguiente nomenclatura:
                                <br />
                                <DocumentIcon style={{fontSize: "12px"}}/> {`[${this.props.tipoPresentacionSeleccionada===3?'DNISocio':'NroInternación'}_textolibre] o`}
                                <br />
                                <DocumentIcon style={{fontSize: "12px"}}/> {`[${this.props.tipoPresentacionSeleccionada===3?'DNISocio':'NroInternación'}-textolibre]`}
                            </>
                        }
                    >
                        <Typography className={classes.ayuda}>?</Typography>
                    </Tooltip>
                </Container>
                {internacionesCargadas}
                <NuevaInternacion
                    mostrar={this.props.mostrarNuevaInternacion}
                    mostrarHandler={this.cambiarVisibilidadBtn}
                    codPrestador={this.props.prestadorSeleccionado.codPrestador}
                    internacion={internacion}
                    idPresentacion={this.props.tipoPresentacionSeleccionada}
                    recuperarInformacionHandler={
                        this.recuperarInformacionParaNuevaInternacion
                    }
                    cargarArchivosHandler={this.cargarArchivosInternacion}
                />
                <InternacionesMasivo
                    deshabilitado={this.props.soloVista}
                    deshabilitarNueva={this.props.mostrarNuevaInternacion}
                    deshabilitarHandle={this.cambiarVisibilidadBtn}
                />
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    internacion: state.internacionesReducer.internacion,
    pathTemp: state.nuevaPresentacionReducer.pathTemporal,
    internaciones: state.nuevaPresentacionReducer.internaciones,
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    tipoPrestacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPrestacionSeleccionada,
    tipoPresentacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
    requeridos: state.nuevaPresentacionReducer.requeridos,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    mostrarNuevaInternacion:
        state.nuevaPresentacionReducer.mostrarNuevaInternacion,
    tipoComprobanteSeleccionado:
        state.nuevaPresentacionReducer.tipoComprobantesSeleccionado
});

const actionCreators = {
    recuperarInfoNroInternacion: actions.recuperarInfoNroInternacion,
    actualizarInfoInternacion: actions.actualizarInfoInternacion,
    actualizarNroInternacion: actionsNuevaPresentacion.actualizarNroInternacion,
    subirArchivosNuevaInternacion:
        actionsAdjuntarArchivo.subirArchivosNuevaInternacion,
    subiendoNuevaInternacion: actionsAdjuntarArchivo.subiendoNuevaInternacion,
    obtenerTempIdParaInternacion: actions.obtenerTempIdParaInternacion,
    internacionParaActualizar: actions.internacionParaActualizar,
    actualizarInternacion: actionsNuevaPresentacion.actualizarInternacion,
    actualizarAtriutoPresentacion:
        actionsNuevaPresentacion.actualizarAtriutoPresentacion,
    eliminarInternacion: actionsNuevaPresentacion.eliminarInternacion,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    actualizarAtriutoSnackMensaje:
        actionsSnackMensaje.actualizarAtriutoSnackMensaje,
    actualizarMensajesError: actionsNuevaPresentacion.actualizarMensajesError,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(theme)(ListadoInternaciones));
